const ALGOLIA_INDEX_EN =
  process.env.NEXT_PUBLIC_ALGOLIA_INDEX_EN ?? "vaw_search_en";
const ALGOLIA_INDEX_AF =
  process.env.NEXT_PUBLIC_ALGOLIA_INDEX_AF ?? "vaw_search_af";

/**
 * Returns the Algolia index name for the given locale.
 */
export function getAlgoliaIndexName(locale: string = "en"): string {
  switch (locale) {
    case "af":
      return ALGOLIA_INDEX_AF;
    default:
      return ALGOLIA_INDEX_EN;
  }
}

/**
 * Algolia `filters` clause that hides fully-past events from site-wide search
 * while leaving every other record untouched.
 *
 * Past events are kept in the index (the events directory Past tab needs them),
 * so site-wide search has to exclude them itself for hygiene. Every record
 * indexes `lastOccurrenceUnix`: dated events carry the Unix seconds of their
 * final occurrence, while non-events and date-less events carry the far-future
 * NO_EXPIRY_UNIX sentinel (see @repo/algolia). The filter therefore keeps
 * everything except events whose last occurrence is already in the past.
 *
 * The sentinel exists because Algolia numeric filters only match records that
 * HAVE the attribute — `NOT lastOccurrenceUnix < now` evaluates as
 * `lastOccurrenceUnix >= now` and drops attribute-less records, so omission
 * cannot mean "keep".
 *
 * @param nowUnix "Now" as Unix seconds — capture once per mount so the memoised
 *   filter stays deterministic across renders.
 */
export function excludePastEventsFilter(nowUnix: number): string {
  return `lastOccurrenceUnix >= ${nowUnix}`;
}
